import { inject, Injectable } from "@angular/core";
import { ApiService } from "@shared/data-access/api.service";
import { ProfilePreferences } from "../models/profile.model";
import { urlNewAsistencia } from "@shared/utils/general/url";

const baseUrl = `${urlNewAsistencia}/v1/user-config`

@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    private apiLoad = inject(ApiService)

    getProfile() {
        return this.apiLoad.get<ProfilePreferences>(`${baseUrl}`)
    }

    save(sender:ProfilePreferences) {
        return this.apiLoad.put(`${baseUrl}`, sender)
    }

}